import { AppState } from '@auth0/auth0-react';
import { history } from 'utils/history';

export const onRedirectCallback = (appState: AppState) => {
  history.push(appState && appState.returnTo ? appState.returnTo : window.location.pathname);
};
